import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

interface FinancialOption {
  title: string;
  description: string;
  icon: string;
  route: string;
  requiredRoles: string[];
  color: string; // Tailwind color class
}

@Component({
  selector: 'app-financal-dashboard',
  templateUrl: './financal-dashboard.component.html',
  styleUrls: [] // Eliminamos el CSS personalizado
})
export class FinancalDashboardComponent implements OnInit {
  options: FinancialOption[] = [
    {
      title: 'Domiciliaciones Bancarias',
      description: 'Administra los archivos de cobranza a través de débito automático en los bancos afiliados',
      icon: 'fa fa-credit-card',
      route: '/console/dashboard-direct-debit',
      requiredRoles: ['OWNER', 'FINANCIAL'],
      color: 'bg-blue-100 text-blue-600'
    },
    {
      title: 'Afiliaciones Bancarias',
      description: 'Administra los archivos de afiliación bancaria para débitos automáticos en los bancos afiliados',
      icon: 'fas fa-handshake',
      route: '/console/dashboard-direct-debit-affiliation',
      requiredRoles: ['OWNER', 'FINANCIAL'],
      color: 'bg-blue-100 text-blue-600'
    },
    {
      title: 'Compras Financiadas',
      description: 'Consulta todas las compras financiadas por tienda y por producto',
      icon: 'fas fa-shopping-cart',
      route: '/console/invoice-dashboard',
      requiredRoles: ['OWNER', 'ANALIST'],
      color: 'bg-blue-100 text-blue-600'
    },
    {
      title: 'Gestión de Cuotas',
      description: 'Monitorea las cuotas financiadas por estatus y vencimientos',
      icon: 'fas fa-calendar-alt',
      route: '/console/installments-console',
      requiredRoles: ['OWNER', 'ANALIST'],
      color: 'bg-blue-100 text-blue-600'
    },
    {
      title: 'Verificación de Pagos',
      description: 'Visualiza todos los pagos realizados, filtrados por estatus y por método de pago',
      icon: 'fas fa-money-bill-wave',
      route: '/console/payments',
      requiredRoles: ['OWNER', 'ANALIST'],
      color: 'bg-blue-100 text-blue-600'
    },
    {
      title: 'Comisiones y Tarifas',
      description: 'Administra y configura las comisiones y penalidades aplicables a los diferentes planes de financiamiento',
      icon: 'fas fa-percentage',
      route: '/console/fees',
      requiredRoles: ['OWNER'],
      color: 'bg-green-100 text-green-600'
    },
    {
      title: 'Calculadora de Crédito',
      description: 'Simula y calcula diferentes escenarios de crédito según los diferentes planes de financiamiento',
      icon: 'fas fa-calculator',
      route: '/console/credit-calculator',
      requiredRoles: ['OWNER', 'ANALIST'],
      color: 'bg-blue-100 text-blue-600'
    }
  ];

  userRoles: string[] = [];

  constructor(public _auth: AuthService) {}

  ngOnInit(): void {
    this.userRoles = Array.isArray(this._auth.sessionUser?.profile) ? this._auth.sessionUser.profile : [];
  }

  hasPermission(option: FinancialOption): boolean {
    if (this._auth.hasRbac$.getValue()) {
      return this._auth.hasModuleAccess('finanzas');
    }
    if (!option.requiredRoles || option.requiredRoles.length === 0) return true;
    return option.requiredRoles.some(role => this.userRoles.includes(role));
  }
}
